import { Box, Link } from '@mui/material';

function TalkToSalesLink() {
  return (
    <Box className="talk-to-sales-link">
      <Link
        href="https://www.scylladb.com/pricing#request-pricing"
        target="_blank"
      >
        Talk to sales &gt;
      </Link>
    </Box>
  );
}

export default TalkToSalesLink;
